import { GoogleSignIn } from "@/components/auth/GoogleSignIn.js";


interface SocialSignInButtonsProps {
    redirectPathname: string | null;
}


export function SocialSignInButtons({ redirectPathname }: SocialSignInButtonsProps) {
    return (
        <div className="flex w-full flex-col gap-y-3 py-4">
            <GoogleSignIn redirectPathname={redirectPathname} />
        </div>
    );
}
